import firebase from 'firebase/app';
import 'firebase/database';
import isEmpty from 'lodash/isEmpty';
import getPath from 'lodash/get';
import chunk from 'lodash/chunk';
import moment from 'moment';
import { STATIC_HOMEPAGE_URL } from '../config';
const { getRandomColor } = require('../../server/scripts/utils.js')();
import { soundcastManager } from '../helpers/managers';

export const filterOutSoundcastBundles = (soundcasts = []) => {
  if (isEmpty(soundcasts)) {
    return [];
  }

  return soundcasts.filter(({ bundle = false }) => !bundle);
};

export const hasEpisode = (soundcast = {}) => {
  // empty soundcast
  if (isEmpty(soundcast)) {
    return false;
  }

  // no episodes at all
  const { episodes = {} } = soundcast;
  if (isEmpty(episodes)) {
    return false;
  }

  return true;
};

export const hasSubscriptionPlans = (prices = []) => {
  const subPlans = prices.filter(
    ({ billingCycle = '' }) => !isEmpty(billingCycle) && billingCycle !== 'one time'
  );
  return !isEmpty(subPlans);
};

export const hasOneTimePrice = (prices = []) => {
  const oneTimePrices = prices.filter(
    ({ billingCycle = '' }) => !isEmpty(billingCycle) && billingCycle === 'one time'
  );
  return !isEmpty(oneTimePrices);
};

export const hasCustomPaymentUrl = (soundcast = {}) => {
  const { customPaymentUrl = '' } = soundcast;
  return !isEmpty(customPaymentUrl);
};

export const getLandingPageUrl = (soundcastId, published = false) => {
  const url = [`${STATIC_HOMEPAGE_URL}/soundcasts/${soundcastId}`];
  if (!published) {
    url.push('?preview=true');
  }

  return url.join('');
};

// export const removeListener = (soundcastId, userId) =>
//   firebase.database().ref(`soundcasts/${soundcastId}/subscribed/${userId}`).remove();

export const getSoundcastSubscribers = ({ soundcastId, subscribed = {} }, total = false) => {
  return new Promise(async resolve => {
    try {
      const subscribers = await soundcastManager.getSubscribedObj(soundcastId, subscribed || {});
      const userIds = Object.keys(subscribers);
      if (total) {
        return resolve(userIds.length);
      }

      const requests = userIds.map(userId => {
        return firebase.database().ref(`users/${userId}`).once('value');
      });

      // const snapshots = await Promise.all(requests);
      const maxNumberOfParallelProcessing = 100;
      let snapshots = [];
      const requestsGroups = chunk(requests, maxNumberOfParallelProcessing);
      for (const group of requestsGroups) {
        const groupData = await Promise.all(group);
        snapshots = snapshots.concat(groupData);
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      const users = snapshots.reduce((accum, snapshot) => {
        if (snapshot.exists() && snapshot.hasChild('email')) {
          const user = snapshot.val();
          const userId = snapshot.key;

          const subscription = getPath(user.soundcasts, soundcastId, {});
          const {
            subscription_ended: isSubscriptionEnded = false,
            current_period_end = 0,
          } = subscription;
          const isCurrentPeriodEnd = current_period_end > 0 && current_period_end < moment().unix();

          // This will exclude from the list everyone whose paid period has already ended.
          if (isCurrentPeriodEnd) {
            return accum;
          }
          //// This will only exclude from the list those who have terminated their subscription,
          //// but the paid period has not yet ended.
          // if (isCurrentPeriodEnd > 0 && isSubscriptionEnded) {
          //   return accum;
          // }

          accum.push({
            id: userId,
            ...user,
          });
        } else {
          // from here, the user is no longer valid
          // lets remove them from subscribed prop
          // removeListener(soundcastId, snapshot.key);
          console.log('no longer exist', snapshot.key);
        }

        return accum;
      }, []);

      if (total) {
        return resolve(users.length);
      }
      resolve(users);
    } catch (err) {
      console.log(`ERROR: getSoundcastSubscribers ${soundcastId} catch ${err.message}`);
      if (total) {
        return resolve(0);
      }
      resolve([]);
    }
  });
};

export const getSoundcastItunesImageUrl = soundcast => {
  const { itunesImage, imageURL, imageUrl, title } = soundcast || {};
  const itunesImageChecked = (itunesImage || imageURL || imageUrl || '' )
    .replace('dummyimage.com/300.png/', 'dummyimage.com/1400.png/');
  return isEmpty(itunesImageChecked)
    ? `https://dummyimage.com/1400.png/${getRandomColor()}/ffffff&text=${encodeURIComponent(title || ' NEW ')}`
    : itunesImageChecked;
};
